import { paperClasses } from "@mui/material/Paper";

export const MuiCard = {
    styleOverrides: {
        root: ({ theme }) => {
            return {
                borderRadius: "12px",
                border: "1px solid var(--mui-palette-divider)",
                backgroundImage: "none",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.06)", // Very subtle shadow
                transition: "all 0.2s ease-in-out",
                //"&:hover": {
                // Only apply hover effects to clickable cards (those with CardActionArea)
                // Using :has() selector for modern browsers
                "&:has(.MuiCardActionArea-root):hover": {
                    borderColor: "var(--mui-palette-primary-main)",
                    boxShadow: "0 0 55px -18px rgba(0, 0, 0, .3), 0 0 13px rgba(9, 0, 51, .1)",
                    // Keep background unchanged - CardActionArea theme handles preventing darkening
                    backgroundColor: "var(--mui-palette-background-paper)",
                },
                // Also apply hover when CardActionArea itself is hovered (for better compatibility)
                "&:has(.MuiCardActionArea-root:hover)": {
                    borderColor: "var(--mui-palette-primary-main)",
                    boxShadow: "0 0 55px -18px rgba(0, 0, 0, .3), 0 0 13px rgba(9, 0, 51, .1)",
                    // Keep background unchanged
                    backgroundColor: "var(--mui-palette-background-paper)",
                },
                // Static cards (without CardActionArea) have no hover effect by default

                [`&.${paperClasses.elevation1}`]: {
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.06)",
                },
            };
        },
    },
};
